import { configureStore } from '@reduxjs/toolkit';
import { rootReducer, storeMiddleware } from '@/app/rootReducer';
import { setSessionId, setPremiumSearch, setView } from '@reducers/systemSlice';
import { setLanguage } from '@reducers/languageSlice';
import { setAppStore } from '@/app/storeRegistry';

/**
 * Redux-Store fuer das Such-Widget.
 *
 * Der Store benutzt bewusst DIESELBEN Reducer wie der ibe_client
 * (siehe src/app/rootReducer.js). Frueher gab es hier eine handgeschriebene
 * Minimalfassung der Slices; die lief dem Client davon und liess das Widget
 * abstuerzen, sobald eine Komponente einen Slice las, den die Kopie nicht hatte.
 *
 * Der Anfangszustand wird nicht ueber preloadedState gesetzt, sondern ueber die
 * regulaeren Actions. So bleibt der initialState der Slices unangetastet.
 *
 * @param {object} initialState
 * @param {string} initialState.sessionId - Session UUID
 * @param {string} initialState.tenantID - Tenant UUID
 * @param {string} initialState.language - Sprachcode (de, en, tr)
 * @param {boolean} initialState.premiumSearch - alle Kategorie-Badges zeigen
 */
export function createWidgetStore(initialState = {}) {
  const {
    sessionId = '',
    language = 'de',
    premiumSearch = false,
  } = initialState;

  const store = configureStore({
    middleware: storeMiddleware,
    reducer: rootReducer,
  });

  // Zugriff fuer Code ausserhalb von React-Komponenten (siehe storeRegistry.js).
  setAppStore(store);

  if (sessionId) store.dispatch(setSessionId(sessionId));
  store.dispatch(setView('widget'));
  store.dispatch(setLanguage(language));
  store.dispatch(setPremiumSearch(!!premiumSearch));

  return store;
}

export default createWidgetStore;
